import { defineComponent as _defineComponent } from 'vue';
import { useAddFeedbackMutation } from '~/types/types';
import { renderMarkdown } from '~/functions/markdown';
export default /*#__PURE__*/_defineComponent({
  __name: 'BugReport',
  props: {
    value: {
      type: Boolean
    },
    hideActivator: {
      type: Boolean,
      default: false
    }
  },
  emits: ["input"],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    var props = __props;
    var route = useRoute();
    var bugReport = ref({
      title: 'Feedback',
      description: '',
      url: route.fullPath
    });
    var _useNuxtApp = useNuxtApp(),
      $i18n = _useNuxtApp.$i18n;
    var _useAddFeedbackMutati = useAddFeedbackMutation(),
      addFeedback = _useAddFeedbackMutati.mutate,
      loading = _useAddFeedbackMutati.loading;
    var localDialogOpen = ref(false);
    var dialogOpen = computed({
      get: function get() {
        return props.value === undefined ? localDialogOpen.value : props.value;
      },
      set: function set(value) {
        localDialogOpen.value = value;
        emit('input', value);
      }
    });
    return {
      __sfc: true,
      props: props,
      emit: emit,
      route: route,
      bugReport: bugReport,
      $i18n: $i18n,
      addFeedback: addFeedback,
      loading: loading,
      localDialogOpen: localDialogOpen,
      dialogOpen: dialogOpen,
      renderMarkdown: renderMarkdown
    };
  }
});